// CHA1-3211: every processor invite uses a unique per-(business account, processor) email so
// replies routed to the catch-all inbox can be matched back to who/what they're for -
// `cr-{baname}_{ppname}_team_{BAID}@chargeback.io` (e.g. `cr-unsubby_stripe_team_123@chargeback.io`).
// The `cr-` prefix is required: the catch-all mailbox only accepts addresses starting with it and
// bounces the rest. Both name parts are lowercased - an email local-part shouldn't depend on casing.
const sanitizeNamePart = (value) =>
  (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "")

export const generateInviteEmail = ({ businessAccount, pp }) => {
  const baName = sanitizeNamePart(businessAccount?.name)
  const baId = businessAccount?.id
  const ppName = sanitizeNamePart(pp)

  if (!baName || !baId || !ppName) return null

  return `cr-${baName}_${ppName}_team_${baId}@chargeback.io`
}
